import { Mesh, MeshBasicMaterial, PlaneGeometry } from "three";
import { RegisterHitPlaneConfig } from "../Config/RegisterHitPlaneConfig.js";
import { ViewType } from "../Models/AppModel.js";
import { bindedModelBase } from "../Models/BindedModel.js";
import { Point } from "./Primitive/Point.js";
/**
 * Tool to allow registering points clicking on the scene.
 */
export class RegisterHitPlane extends Mesh {
    constructor(viewType) {
        super(new PlaneGeometry(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, 1, 1), new MeshBasicMaterial({ visible: false }));
        this._points = [];
        this.name = "RegisterHitPlane";
        this.position.setZ(100);
        this._viewType = viewType;
        this._isRegisteringClick = this._viewType === ViewType.AP ? "isRegisteringClickAP" : "isRegisteringClickLT";
        this.bindProperty("visible", (m) => { return m[this._isRegisteringClick]; }, [this._isRegisteringClick]);
        this.bindEvent("onMouseDown", () => {
            this._oldCameraState = { position: this._camera.position.clone(), zoom: this._camera.zoom };
        });
        this.bindEvent("onMouseUp", (args) => {
            this._camera.position.equals(this._oldCameraState.position) && this._camera.zoom === this._oldCameraState.zoom && this.registerPoint(args.point);
        });
    }
    /**
     * Starts registering points for a specific object.
     */
    startRegisteringForObj(obj, camera, callbacks = {}, restartOnError = false) {
        if (this._countReachedEvent) {
            this.clearRegisterdPoints();
            this.clearTempValues();
        }
        this._camera = camera;
        this._countLimit = obj.pointsToRegister;
        this._callbacks = callbacks;
        this._registeringObj = obj;
        this._countReachedEvent = (event) => {
            if (obj.handleRegisteredPoints(event.args)) {
                this.triggerCallback("onRegSuccess");
                this.triggerCallback("onRegEnd", true);
                bindedModelBase[this._isRegisteringClick] = false;
            }
            else {
                this.triggerCallback("onRegError");
                if (!restartOnError) {
                    this.triggerCallback("onRegEnd", false);
                    bindedModelBase[this._isRegisteringClick] = false;
                }
            }
        };
        this.addEventListener('countReached', this._countReachedEvent);
        bindedModelBase[this._isRegisteringClick] = true;
        this.triggerCallback("onRegStart");
    }
    /**
     * Deletes all placed points and stop current registering.
     */
    stopRegistering() {
        this.clearRegisterdPoints();
        this.triggerCallback("onRegCancel");
        this.triggerCallback("onRegEnd", false);
        this.clearTempValues();
        bindedModelBase[this._isRegisteringClick] = false;
    }
    /**
     * Deletes all placed points and start a new registering.
     */
    resetRegistering() {
        this.clearRegisterdPoints();
        this.triggerCallback("onRegReset");
        bindedModelBase[this._isRegisteringClick] = true;
    }
    clearTempValues() {
        this._countLimit = -1;
        this.removeEventListener('countReached', this._countReachedEvent);
        this._callbacks = {};
        this._countReachedEvent = undefined;
        this._registeringObj = undefined;
        this._camera = undefined;
        this._oldCameraState = undefined;
    }
    registerPoint(position) {
        this.addRegisteredPoint(position);
        if (this._points.length === this._countLimit) {
            this.dispatchEvent({ type: 'countReached', args: this.popRegisteredPoints() });
        }
    }
    addRegisteredPoint(position) {
        const point = new Point("SelfGeneratedPoint", RegisterHitPlaneConfig.point_color, position);
        this.add(point);
        this._points.push(point);
    }
    popRegisteredPoints() {
        const positions = this._points.map(x => x.position);
        this.clearRegisterdPoints();
        return positions;
    }
    clearRegisterdPoints() {
        for (const point of this._points) {
            point.dispose();
        }
        this._points = [];
    }
    triggerCallback(name, success) {
        this._callbacks[name] && this._callbacks[name](success); // TODO investigate
        this._registeringObj[name] && this._registeringObj[name](success);
    }
}
//# sourceMappingURL=RegisterHitPlane.js.map